import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import SendEmailRequest from '../../commons/mappings/sendEmailRequest.mapping';

class SendEmailProvider {

    constructor() {
        this.paths              = URLConfiguration.paths;
        this.sendEmailRequest   = new SendEmailRequest();
        this.apiProvider        = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
    }

    enviarCorreo = async (datosEnvioCorreo) => {
        const headers   = HeadersMapping.getHeaderService();
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.otp.enviarCorreo, {});
        const request   = this.sendEmailRequest.getRequestSendEmail(datosEnvioCorreo);
        let response    = null;
        try {
            response = await this.apiProvider.post(pathNew, request, { headers });
        } catch (error) {
            console.log(error);
        }
        return response
    }

}

export default SendEmailProvider;